import { render } from "./index.vue?vue&type=template&id=32404712&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32404712&scoped=true&lang=css"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32404712"]])

export default __exports__